var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"industry__screen noselect"},[_c('markdown',{staticClass:"industry__title",attrs:{"color":'#3a4f41',"text":_vm.$t('stories_screen_2_text')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }